import { useEffect, useState } from "react";
import { openExternalUrl } from "@/utils/openExternalUrl";
import {
  ensureTelegramWebAppScript,
  isTelegramRuntime,
  resolveTelegramInitData,
} from "@/utils/telegramWebApp";

export function useTelegram() {
  const [tg, setTg] = useState(null);
  const [user, setUser] = useState(null);
  const [initData, setInitData] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function hydrate() {
      if (isTelegramRuntime()) {
        await ensureTelegramWebAppScript();
        const resolved = await resolveTelegramInitData();
        if (cancelled) return;
        const telegram = window?.Telegram?.WebApp;
        if (!telegram) return;
        telegram.ready();
        telegram.expand();
        setTg(telegram);
        setUser(telegram.initDataUnsafe?.user || null);
        setInitData(resolved || telegram.initData || "");
        return;
      }

      const telegram = window?.Telegram?.WebApp;
      if (!telegram || cancelled) return;
      telegram.ready();
      telegram.expand();
      setTg(telegram);
      setUser(telegram.initDataUnsafe?.user || null);
      setInitData(telegram.initData || "");
    }

    hydrate();
    return () => {
      cancelled = true;
    };
  }, []);

  const shareUrl = (url, text) => {
    if (tg) {
      tg.openTelegramLink(`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text || "")}`);
    } else {
      window.open(`https://t.me/share/url?url=${encodeURIComponent(url)}`, '_blank');
    }
  };

  const openLink = (url) =>
    // Prefer live window.Telegram.WebApp over React state: state can still be null
    // while the SDK is already present; after async payment POSTs, window.open is blocked.
    openExternalUrl(url, { webApp: tg || (typeof window !== "undefined" ? window.Telegram?.WebApp : null) });

  const hapticFeedback = (type = 'light') => {
    try {
      tg?.HapticFeedback?.impactOccurred(type);
    } catch {
      // Haptics are best-effort: older Telegram clients throw on unsupported calls.
    }
  };

  // Отправить команду боту через backend (не закрывает Mini App)
  const sendBotCommand = async (command, apiCall) => {
    try {
      await apiCall('/bot/command', {
        method: 'POST',
        data: { command }
      });
    } catch (e) {
      console.warn('sendBotCommand failed:', e);
    }
  };

  return { tg, user, initData, shareUrl, openLink, hapticFeedback, sendBotCommand };
}
